var components
try {
  components = {
    "u-Form": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--form/u--form" */ "@/uni_modules/uview-ui/components/u--form/u--form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-form-item/u-form-item" */ "@/uni_modules/uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    "u-Image": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--image/u--image" */ "@/uni_modules/uview-ui/components/u--image/u--image.vue"
      )
    },
    "u-Text": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--text/u--text" */ "@/uni_modules/uview-ui/components/u--text/u--text.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uniDatetimePicker: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-datetime-picker/components/uni-datetime-picker/uni-datetime-picker" */ "@/uni_modules/uni-datetime-picker/components/uni-datetime-picker/uni-datetime-picker.vue"
      )
    },
    uUpload: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-upload/u-upload" */ "@/uni_modules/uview-ui/components/u-upload/u-upload.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }